import { render, staticRenderFns } from "./EventProp.vue?vue&type=template&id=e559a68e&scoped=true"
import script from "./EventProp.vue?vue&type=script&lang=js"
export * from "./EventProp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e559a68e",
  null
  
)

export default component.exports